import { FeedbackPageData, FeedbackPageFlow, FeedbackPageType } from './types'

export const feedbackPageData: FeedbackPageData = {
  'pt-BR': {
    [FeedbackPageFlow.LEAD_FORM]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Informações recebidas',
        description: 'Agora, vamos analisar e entraremos em contato se necessário.',
        primaryButton: 'Ir pra Home',
      },
      [FeedbackPageType.ERROR]: {
        title: 'Houve um erro por aqui',
        primaryButton: 'Ir pra Home',
      },
    },
  },
  'en-US': {
    [FeedbackPageFlow.LEAD_FORM]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Information received',
        description: "We'll review the information and contact you if needed.",
        primaryButton: 'Go to Home',
      },
      [FeedbackPageType.ERROR]: {
        title: 'There was an error around here',
        primaryButton: 'Go to Home',
      },
    },
  },
  'es-ES': {
    [FeedbackPageFlow.LEAD_FORM]: {
      [FeedbackPageType.SUCCESS]: {
        title: 'Información enviada',
        description: 'Pronto estaremos en contacto con las mejores opciones para ti.',
        primaryButton: 'Ir al inicio',
      },
      [FeedbackPageType.ERROR]: {
        title: 'Hubo un error por aquí',
        primaryButton: 'Ir al inicio',
      },
    },
  },
}
